/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-void */
/* eslint-disable no-alert */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import Environments from "../../Environments";
import { MESSAGE_KIND_GET, TRAINING_TYPE_CAREER } from "../../Constants";
import MOCK_DATA from "../../mock/data";
import { useScreenSize, ZINDEX_HEADER } from "../Theme";

import WindowOpener from "../../logic/windowOpener";
import { isNew } from "../../logic/information/Information";
import NoticeMessageListService, { NoticeMessageListResponse, MsgListItem } from "../../logic/api/NoticeMessageListService";
import NoticeWhatsNewService, { NoticeWhatsNewResponse, WhatsNewListItem } from "../../logic/api/NoticeWhatsNewService";
import LmFunctionService from "../../logic/api/LmFunctionService";
import { getHeaderBackground } from "../../logic/companies/Companies";
import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import { logout } from "../../logic/logout";
import SompoContext from "../../logic/context/SompoContext";

import Mobile from "./Mobile";
import Desktop from "./Desktop";

export interface HeaderProps {
    hasNewInformation: boolean;
    handleHome: () => void;
    handleInfo: () => void;
    handleSkillMap: () => void;
    handleProfile: () => void;
    handleLogout: () => void;
    handleTrainingList: () => void;
    setTrainingSearchText: React.Dispatch<React.SetStateAction<string>>;
    handleOpenManagerWindow?: () => void;
}

const lmFunctionService = new LmFunctionService();
const messageService = new NoticeMessageListService();
const whatsnewService = new NoticeWhatsNewService();

const getHeaderStyle = () => {
    const defaultStyle = {
        zIndex: ZINDEX_HEADER,
        background: "#fefefe",
        color: "#444C55",
        height: "64px",
        "& .MuiToolbar-root": {
            p: 0,
        },
    };

    const background = getHeaderBackground();
    if (!background) {
        return defaultStyle;
    }

    // 背景画像が設定されている場合
    return Object.assign(defaultStyle, {
        backgroundImage: background,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
        backgroundPosition: "center bottom",
    });
};

const checkNewInformation = (setHasNewInformation: React.Dispatch<React.SetStateAction<boolean>>) => {
    if (Environments.MOCK) {
        setHasNewInformation(true);
        return;
    }

    const fetch = async () => {
        try {
            let hasNew: boolean = false;

            // メッセージ一覧を取得
            await messageService.noticeMessageList(
                { kind: MESSAGE_KIND_GET },
                (messages: NoticeMessageListResponse) => {
                    const newMessage = (messages.msgList || []).find((message: MsgListItem) => isNew(message.startDateStr));
                    if (newMessage) {
                        hasNew = true;
                        setHasNewInformation(true);
                    }
                },
                (error: any) => {
                    throw error;
                }
            );
            if (hasNew) return;

            // What's New一覧を取得
            await whatsnewService.noticeWhatsNew(
                {},
                (messages: NoticeWhatsNewResponse) => {
                    const newMessage = (messages.whatsNewList || []).find((message: WhatsNewListItem) => isNew(message.startDateStr));
                    if (newMessage) {
                        setHasNewInformation(true);
                    }
                },
                (error: any) => {
                    throw error;
                }
            );
        } catch (error: unknown) {
            console.error(error);
            showErrorMessage({ message: "お知らせの取得に失敗しました。", error });
        }
    };
    void fetch();
};

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { desktop } = useScreenSize();
    const sompoContext = React.useContext(SompoContext);
    const currentPage = location.pathname;
    const onHome = currentPage === "/home";
    const onInformationList = currentPage === "/information";
    const onSkill = currentPage === "/skill";
    const onProfile = currentPage === "/profile";

    // topに遷移
    const handleHome = () => {
        if (onHome) {
            return;
        }
        navigate("/home");
    };

    // お知らせ画面に遷移
    const handleInfo = () => {
        if (onInformationList) {
            return;
        }
        navigate("/information");
    };

    // スキル管理画面に遷移
    const handleSkillMap = () => {
        if (onSkill) {
            return;
        }
        navigate("/skill");
    };

    // プロフィール画面に遷移
    const handleProfile = () => {
        if (onProfile) {
            return;
        }
        navigate("/profile");
    };

    // ログアウト
    const handleLogout = () => {
        logout();
    };

    // 講座検索に使用
    const [trainingSearchText, setTrainingSearchText] = useState("");

    // 講座一覧に遷移
    const handleTrainingList = () => {
        sompoContext.setSearchText(trainingSearchText);
        navigate("/trainingList", { state: { freeword: trainingSearchText, searchMode: TRAINING_TYPE_CAREER } });
    };

    // 管理者画面表示
    const openManagerWindow = () => {
        if (!Environments.MOCK) {
            const fetch = async () => {
                await lmFunctionService.openManager((error: any) => {
                    console.error(error);
                    showErrorMessage({ message: "管理者画面の表示に失敗しました。", error });
                });
            };
            WindowOpener.openLmWindow(fetch);
        } else {
            const url = MOCK_DATA.URL.MANAGER;
            WindowOpener.open(url);
        }
    };

    // NEW表示のお知らせがあるか
    const [hasNewInformation, setHasNewInformation] = React.useState(false);
    useEffect(() => {
        checkNewInformation(setHasNewInformation);
    }, []);

    return (
        <>
            <AppBar position="fixed" elevation={0} sx={getHeaderStyle()}>
                <Toolbar sx={{ height: "100%" }}>
                    {desktop ? (
                        <Desktop
                            hasNewInformation={hasNewInformation}
                            handleHome={handleHome}
                            handleInfo={handleInfo}
                            handleSkillMap={handleSkillMap}
                            handleProfile={handleProfile}
                            handleLogout={handleLogout}
                            handleTrainingList={handleTrainingList}
                            setTrainingSearchText={setTrainingSearchText}
                            handleOpenManagerWindow={openManagerWindow}
                        />
                    ) : (
                        <Mobile
                            hasNewInformation={hasNewInformation}
                            handleHome={handleHome}
                            handleInfo={handleInfo}
                            handleSkillMap={handleSkillMap}
                            handleProfile={handleProfile}
                            handleLogout={handleLogout}
                            handleTrainingList={handleTrainingList}
                            setTrainingSearchText={setTrainingSearchText}
                        />
                    )}
                </Toolbar>
            </AppBar>
        </>
    );
};

export default Header;
